import { CREATION_TYPES, ROLES } from '../relation/relation.const'

export const ADULT_MIN_AGE = 18

export const CLIENT_TYPES = {
  retail: 'retail',
  private: 'private',
  wealth: 'wealth',
}

const PERSON_CREATION_TYPE_FULL = CREATION_TYPES.currentUser

export const PERSON_CREATION_TYPES_BASE = {
  parent: ROLES.parent,
  sibling: ROLES.sibling,
  brotherNephewNiece: ROLES.brotherNephewNiece,
  sisterNephewNiece: ROLES.sisterNephewNiece,
  paternalUncleAunt: ROLES.paternalUncleAunt,
  maternalUncleAunt: ROLES.maternalUncleAunt,
  grandparent: ROLES.grandparent,
  other: ROLES.other,
}

export const PERSON_CREATION_TYPES = {
  partner: ROLES.partner,
  child: ROLES.child,
  grandchild: ROLES.grandchild,
  ...PERSON_CREATION_TYPES_BASE,
}

export const CREATION_TYPE_GENERATION = {
  [PERSON_CREATION_TYPE_FULL]: 0,
  [PERSON_CREATION_TYPES.partner]: 0,
  [PERSON_CREATION_TYPES.child]: 1,
  [PERSON_CREATION_TYPES.parent]: -2,
  [PERSON_CREATION_TYPES.sibling]: -1,
  [PERSON_CREATION_TYPES.paternalUncleAunt]: -2,
  [PERSON_CREATION_TYPES.maternalUncleAunt]: -2,
  [PERSON_CREATION_TYPES.other]: -1,
  [PERSON_CREATION_TYPES.sisterNephewNiece]: 1,
  [PERSON_CREATION_TYPES.brotherNephewNiece]: 1,
  [PERSON_CREATION_TYPES.grandparent]: -3,
}

export const ALTERNATE_RESIDENCE_LEGAL_CAPACITIES = [
  'minor',
  'minor_under_judicial_control',
  'minor_under_guardianship',
]

export const NO_ALTERNATE_RESIDENCE_MIN_AGE = 18
